exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#add_data_element_modal .modal-content {\n  overflow-y: visible;\n}\n.document-editor .ck .fa.fa-2x {\n  font-size: 1.5em !important;\n}\n.document-editor .ck .fa-stack {\n  position: relative;\n}\n.document-editor .ck .fa-stack .fa-stack-2x.fa-file {\n  font-size: 1.5em !important;\n}\n.document-editor .ck .fa-stack .fa-stack-1x.fa-plus {\n  left: 5px;\n  top: 10px;\n  position: absolute;\n  color: #fff !important;\n}\n", ""]);

// exports
